import type { CountryCode } from 'libphonenumber-js/min'
import { parsePhoneNumberFromString } from 'libphonenumber-js/min'

export type MobileNumber = { country: CountryCode; number: string }

export function parseMobileNumber(value?: MobileNumber) {
    if (!value?.number.trim()) return undefined
    const input = value.number.trim().replace(/^00/, '+')
    return parsePhoneNumberFromString(input, { defaultCountry: value.country, extract: false })
}
